// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PatientInfoModule-module__font-s-10___ofWEg {
  font-size: 10px !important;
}

.PatientInfoModule-module__font-s-12___WNEoB {
  font-size: 12px !important;
}

.PatientInfoModule-module__font-s-13___eGHhn {
  font-size: 13px !important;
}

.PatientInfoModule-module__font-s-14___D3nio {
  font-size: 14px !important;
}

.PatientInfoModule-module__font-s-15___Ppa45 {
  font-size: 15px !important;
}

.PatientInfoModule-module__font-s-16___upLTG {
  font-size: 16px !important;
}

.PatientInfoModule-module__font-s-18___qE0Bf {
  font-size: 18px !important;
}

.PatientInfoModule-module__font-s-20___EcdUC {
  font-size: 20px !important;
}

.PatientInfoModule-module__font-s-22___OMPtW {
  font-size: 22px !important;
}

.PatientInfoModule-module__font-s-28___shs6o {
  font-size: 28px !important;
}

.PatientInfoModule-module__font-w-400___MHPwO {
  font-weight: 400 !important;
}

.PatientInfoModule-module__font-w-500___X0fWR {
  font-weight: 500 !important;
}

.PatientInfoModule-module__font-w-600___Wr4zN {
  font-weight: 600 !important;
}

.PatientInfoModule-module__font-w-700___wsbEQ {
  font-weight: 700 !important;
}

.PatientInfoModule-module__p-5___EI56p {
  padding: 5px !important;
}

.PatientInfoModule-module__p-12___neJlm {
  padding: 12px !important;
}

.PatientInfoModule-module__p-16___rTEMT {
  padding: 16px !important;
}

.PatientInfoModule-module__p-30___Yc6m4 {
  padding: 30px !important;
}

.PatientInfoModule-module__p-b-0___KGDX2 {
  padding-bottom: 0 !important;
}

.PatientInfoModule-module__p-b-5___h6nUI {
  padding-bottom: 5px !important;
}

.PatientInfoModule-module__p-b-10___MpFFg {
  padding-bottom: 10px !important;
}

.PatientInfoModule-module__p-b-12___dIlxD {
  padding-bottom: 12px !important;
}

.PatientInfoModule-module__p-b-16___s_uwL {
  padding-bottom: 16px !important;
}

.PatientInfoModule-module__p-b-18___y1ifi {
  padding-bottom: 18px !important;
}

.PatientInfoModule-module__p-b-20___BVEdK {
  padding-bottom: 20px !important;
}

.PatientInfoModule-module__p-b-25___ECEW9 {
  padding-bottom: 25px !important;
}

.PatientInfoModule-module__p-b-30___hXBsN {
  padding-bottom: 30px !important;
}

.PatientInfoModule-module__p-b-50___rp_6G {
  padding-bottom: 50px !important;
}

.PatientInfoModule-module__p-t-0___Eo44c {
  padding-top: 0 !important;
}

.PatientInfoModule-module__p-t-12___SVmMb {
  padding-top: 12px !important;
}

.PatientInfoModule-module__p-t-16___BZgRe {
  padding-top: 16px !important;
}

.PatientInfoModule-module__p-t-18___jCusE {
  padding-top: 18px !important;
}

.PatientInfoModule-module__p-t-20___Gb4hn {
  padding-top: 20px !important;
}

.PatientInfoModule-module__p-t-30___OV56G {
  padding-top: 30px !important;
}

.PatientInfoModule-module__p-t-40___HNF4f {
  padding-top: 40px !important;
}

.PatientInfoModule-module__p-t-50___WNuPb {
  padding-top: 50px !important;
}

.PatientInfoModule-module__p-l-20___nECSM {
  padding-left: 20px !important;
}

.PatientInfoModule-module__p-l-30___hN3Xw {
  padding-left: 30px !important;
}

.PatientInfoModule-module__p-l-40___SvDr0 {
  padding-left: 40px !important;
}

.PatientInfoModule-module__p-r-16___bYZhe {
  padding-right: 16px !important;
}

.PatientInfoModule-module__p-r-20___qAmGS {
  padding-right: 20px !important;
}

.PatientInfoModule-module__p-r-30___I0CmU {
  padding-right: 30px !important;
}

.PatientInfoModule-module__p-r-50___JThlO {
  padding-right: 50px !important;
}

.PatientInfoModule-module__p-r-60___hvAq_ {
  padding-right: 60px !important;
}

.PatientInfoModule-module__m-b-1___GDExR {
  margin-bottom: 1px !important;
}

.PatientInfoModule-module__m-b-2___bPAO3 {
  margin-bottom: 2px !important;
}

.PatientInfoModule-module__m-b-6___jzdsV {
  margin-bottom: 6px !important;
}

.PatientInfoModule-module__m-b-8___WmZKS {
  margin-bottom: 8px !important;
}

.PatientInfoModule-module__m-b-10___HfH2e {
  margin-bottom: 10px !important;
}

.PatientInfoModule-module__m-b-14___olKRt {
  margin-bottom: 14px !important;
}

.PatientInfoModule-module__m-b-16___VApka {
  margin-bottom: 16px !important;
}

.PatientInfoModule-module__m-b-20___Hr8an {
  margin-bottom: 20px !important;
}

.PatientInfoModule-module__m-b-22___uK01b {
  margin-bottom: 22px !important;
}

.PatientInfoModule-module__m-b-24___BdwaT {
  margin-bottom: 24px !important;
}

.PatientInfoModule-module__m-b-30___IH7uq {
  margin-bottom: 30px !important;
}

.PatientInfoModule-module__m-b-32___P0ujz {
  margin-bottom: 32px !important;
}

.PatientInfoModule-module__m-b-40___fpHQK {
  margin-bottom: 40px !important;
}

.PatientInfoModule-module__m-t-2___e23zj {
  margin-top: 2px !important;
}

.PatientInfoModule-module__m-t-3___MlnYE {
  margin-top: 3px !important;
}

.PatientInfoModule-module__m-t-4___APdnn {
  margin-top: 4px !important;
}

.PatientInfoModule-module__m-t-5___ywnQX {
  margin-top: 5px !important;
}

.PatientInfoModule-module__m-t-8___yA3pd {
  margin-top: 8px !important;
}

.PatientInfoModule-module__m-t-10___eyPeV {
  margin-top: 10px !important;
}

.PatientInfoModule-module__m-t-15___SMgh9 {
  margin-top: 15px !important;
}

.PatientInfoModule-module__m-t-16___ZlgnW {
  margin-top: 16px !important;
}

.PatientInfoModule-module__m-t-20___ykiz8 {
  margin-top: 20px !important;
}

.PatientInfoModule-module__m-t-22___F4MaJ {
  margin-top: 22px !important;
}

.PatientInfoModule-module__m-t-30___ocAK0 {
  margin-top: 30px !important;
}

.PatientInfoModule-module__m-t-32___UggSp {
  margin-top: 32px !important;
}

.PatientInfoModule-module__m-l-auto___V4jKH {
  margin-left: auto !important;
}

.PatientInfoModule-module__m-l-4___qf1vx {
  margin-left: 4px !important;
}

.PatientInfoModule-module__m-l-5___t04Lm {
  margin-left: 5px !important;
}

.PatientInfoModule-module__m-l-6___d7syO {
  margin-left: 6px !important;
}

.PatientInfoModule-module__m-l-8___ZtqUZ {
  margin-left: 8px !important;
}

.PatientInfoModule-module__m-l-10___wzunu {
  margin-left: 10px !important;
}

.PatientInfoModule-module__m-l-16___wIq6E {
  margin-left: 16px !important;
}

.PatientInfoModule-module__m-l-20___HURVY {
  margin-left: 20px !important;
}

.PatientInfoModule-module__m-l-24___Y8rD8 {
  margin-left: 24px !important;
}

.PatientInfoModule-module__m-l-30___DeXXm {
  margin-left: 30px !important;
}

.PatientInfoModule-module__m-l-35___ILPqA {
  margin-left: 35px !important;
}

.PatientInfoModule-module__m-l-40____a9fA {
  margin-left: 40px !important;
}

.PatientInfoModule-module__m-r-8___GTxoa {
  margin-right: 8px !important;
}

.PatientInfoModule-module__m-r-10___MeIbP {
  margin-right: 10px !important;
}

.PatientInfoModule-module__m-r-16___GZO3I {
  margin-right: 16px !important;
}

.PatientInfoModule-module__m-r-20___hVM34 {
  margin-right: 20px !important;
}

.PatientInfoModule-module__m-r-24___ckHfw {
  margin-right: 24px !important;
}

.PatientInfoModule-module__m-r-30___t9vOh {
  margin-right: 30px !important;
}

.PatientInfoModule-module__m-r-40___cP7Cv {
  margin-right: 40px !important;
}

.PatientInfoModule-module__border-r-3___KuLPh {
  border-radius: 3px !important;
}

.PatientInfoModule-module__border-r-4___gQ7d4 {
  border-radius: 4px !important;
}

.PatientInfoModule-module__border-r-6___WLhei {
  border-radius: 6px !important;
}

.PatientInfoModule-module__border-r-10___YZUYs {
  border-radius: 10px !important;
}

.PatientInfoModule-module__border-r-12___m8yL_ {
  border-radius: 12px !important;
}

.PatientInfoModule-module__border-r-16___d1U05 {
  border-radius: 16px !important;
}

.PatientInfoModule-module__border-r-50___X1qC5 {
  border-radius: 50% !important;
}

.PatientInfoModule-module__primary-border___Wohq_ {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.PatientInfoModule-module__primary-border-b___HkGaw {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.PatientInfoModule-module__primary-border-t___YrN7Q {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.PatientInfoModule-module__primary-border-l___Mdd4v {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.PatientInfoModule-module__primary-border-r___i8J4K {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.PatientInfoModule-module__secondary-border___eYGbv {
  border: 1px solid #637768;
}

.PatientInfoModule-module__secondary-border-b___dVOcX {
  border-bottom: 1px solid #637768;
}

.PatientInfoModule-module__secondary-border-t___LAOMe {
  border-top: 1px solid #637768;
}

.PatientInfoModule-module__secondary-border-l___QzkCq {
  border-left: 1px solid #637768;
}

.PatientInfoModule-module__secondary-border-r___Nmkhh {
  border-right: 1px solid #637768;
}

.PatientInfoModule-module__gap-0___qTCH_ {
  gap: 0 !important;
}

.PatientInfoModule-module__gap-2___JAXUg {
  gap: 2px !important;
}

.PatientInfoModule-module__gap-4___gMvdH {
  gap: 4px !important;
}

.PatientInfoModule-module__gap-5___RURvz {
  gap: 5px !important;
}

.PatientInfoModule-module__gap-6___BjZAl {
  gap: 6px !important;
}

.PatientInfoModule-module__gap-8___mmsPl {
  gap: 8px !important;
}

.PatientInfoModule-module__gap-10___MReq3 {
  gap: 10px !important;
}

.PatientInfoModule-module__gap-12___d_jeZ {
  gap: 12px !important;
}

.PatientInfoModule-module__gap-14___fjnle {
  gap: 14px !important;
}

.PatientInfoModule-module__gap-16___MaReI {
  gap: 16px !important;
}

.PatientInfoModule-module__gap-18___CMn4k {
  gap: 18px !important;
}

.PatientInfoModule-module__gap-20___X3WPC {
  gap: 20px !important;
}

.PatientInfoModule-module__gap-24___nvR9U {
  gap: 24px !important;
}

.PatientInfoModule-module__gap-26___hN5dc {
  gap: 26px !important;
}

.PatientInfoModule-module__gap-30___cCA0m {
  gap: 30px !important;
}

.PatientInfoModule-module__gap-32___EXNdv {
  gap: 32px !important;
}

.PatientInfoModule-module__gap-40___sUr24 {
  gap: 40px !important;
}

.PatientInfoModule-module__gap-50___JuGIQ {
  gap: 50px !important;
}

.PatientInfoModule-module__flex-1___buodj {
  flex: 1;
}

.PatientInfoModule-module__flex-none___NmeqD {
  flex: none !important;
}

.PatientInfoModule-module__flex-column___a8_91 {
  display: flex;
  flex-direction: column !important;
}

.PatientInfoModule-module__flex-row___rpblU {
  display: flex;
  flex-direction: row !important;
}

.PatientInfoModule-module__vertically-centered___r57SY {
  display: flex;
  align-items: center !important;
}

.PatientInfoModule-module__horizontally-centered___H5as6 {
  display: flex;
  justify-content: center !important;
}

.PatientInfoModule-module__horizontally-end___FZJRY {
  display: flex;
  justify-content: end !important;
}

.PatientInfoModule-module__vertically-start___YNKAy {
  display: flex;
  align-items: start !important;
}

.PatientInfoModule-module__space-between___rr_UH {
  display: flex;
  justify-content: space-between !important;
}

.PatientInfoModule-module__flex-wrap___N2lHI {
  flex-wrap: wrap !important;
}

.PatientInfoModule-module__height-100___03Dxh {
  height: 100%;
}

.PatientInfoModule-module__width-50___mBc5N {
  width: 50% !important;
}

.PatientInfoModule-module__width-100___MZPCf {
  width: 100%;
}

.PatientInfoModule-module__cursor-pointer___IQDKS {
  cursor: pointer;
}

.PatientInfoModule-module__cursor-not-allowed___byiNC {
  cursor: not-allowed !important;
}

.PatientInfoModule-module__absolute-centered___PfXWW {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.PatientInfoModule-module__absolute___KzzTK {
  position: absolute;
}

.PatientInfoModule-module__relative___UDOko {
  position: relative;
}

.PatientInfoModule-module__fixed___JfwcO {
  position: fixed;
}

.PatientInfoModule-module__visible___WCZo8 {
  opacity: 1;
}

.PatientInfoModule-module__invisible___eNWWI {
  opacity: 0;
}

.PatientInfoModule-module__col-90___i894H {
  width: 90% !important;
}

.PatientInfoModule-module__col-auto___nPAtt {
  width: auto !important;
}

.PatientInfoModule-module__medical-tabs___n1ckP {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.PatientInfoModule-module__medical-table-new___M2D9m {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.PatientInfoModule-module__medical-table-new___M2D9m:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.PatientInfoModule-module__medical-table-new___M2D9m::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.PatientInfoModule-module__medical-table-new___M2D9m::-webkit-scrollbar-track {
  display: none;
}
.PatientInfoModule-module__medical-table-new___M2D9m.PatientInfoModule-module__no-pagination___hxVH4 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.PatientInfoModule-module__medical-table-new___M2D9m.PatientInfoModule-module__no-pagination___hxVH4:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.PatientInfoModule-module__medical-table-new___M2D9m.PatientInfoModule-module__no-pagination___hxVH4::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.PatientInfoModule-module__medical-table-new___M2D9m.PatientInfoModule-module__no-pagination___hxVH4::-webkit-scrollbar-track {
  display: none;
}

.PatientInfoModule-module__medical-table-empty___WdLsC {
  padding: 14px 40px !important;
}

.PatientInfoModule-module__icon-btn___nxQRu {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.PatientInfoModule-module__search-icon___UY43E {
  width: 24px;
  height: 24px;
  align-self: center;
}

.PatientInfoModule-module__disable-select___AuMDx {
  user-select: none;
}

.PatientInfoModule-module__break-word___j2w8S {
  word-break: break-word;
}

.PatientInfoModule-module__popup-clear-btn___REkck {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.PatientInfoModule-module__scroll-m-b-20___Vb1B0 {
  scroll-margin-bottom: 20px;
}

.PatientInfoModule-module__grid___PR8xf {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/DocumentationIndex/modules/PatientInfoModule/PatientInfoModule.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,SAAA;EACA,gDAAA;AA8pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.grid {\n  display: grid;\n  gap: 16px;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `PatientInfoModule-module__font-s-10___ofWEg`,
	"fontS12": `PatientInfoModule-module__font-s-12___WNEoB`,
	"fontS13": `PatientInfoModule-module__font-s-13___eGHhn`,
	"fontS14": `PatientInfoModule-module__font-s-14___D3nio`,
	"fontS15": `PatientInfoModule-module__font-s-15___Ppa45`,
	"fontS16": `PatientInfoModule-module__font-s-16___upLTG`,
	"fontS18": `PatientInfoModule-module__font-s-18___qE0Bf`,
	"fontS20": `PatientInfoModule-module__font-s-20___EcdUC`,
	"fontS22": `PatientInfoModule-module__font-s-22___OMPtW`,
	"fontS28": `PatientInfoModule-module__font-s-28___shs6o`,
	"fontW400": `PatientInfoModule-module__font-w-400___MHPwO`,
	"fontW500": `PatientInfoModule-module__font-w-500___X0fWR`,
	"fontW600": `PatientInfoModule-module__font-w-600___Wr4zN`,
	"fontW700": `PatientInfoModule-module__font-w-700___wsbEQ`,
	"p5": `PatientInfoModule-module__p-5___EI56p`,
	"p12": `PatientInfoModule-module__p-12___neJlm`,
	"p16": `PatientInfoModule-module__p-16___rTEMT`,
	"p30": `PatientInfoModule-module__p-30___Yc6m4`,
	"pB0": `PatientInfoModule-module__p-b-0___KGDX2`,
	"pB5": `PatientInfoModule-module__p-b-5___h6nUI`,
	"pB10": `PatientInfoModule-module__p-b-10___MpFFg`,
	"pB12": `PatientInfoModule-module__p-b-12___dIlxD`,
	"pB16": `PatientInfoModule-module__p-b-16___s_uwL`,
	"pB18": `PatientInfoModule-module__p-b-18___y1ifi`,
	"pB20": `PatientInfoModule-module__p-b-20___BVEdK`,
	"pB25": `PatientInfoModule-module__p-b-25___ECEW9`,
	"pB30": `PatientInfoModule-module__p-b-30___hXBsN`,
	"pB50": `PatientInfoModule-module__p-b-50___rp_6G`,
	"pT0": `PatientInfoModule-module__p-t-0___Eo44c`,
	"pT12": `PatientInfoModule-module__p-t-12___SVmMb`,
	"pT16": `PatientInfoModule-module__p-t-16___BZgRe`,
	"pT18": `PatientInfoModule-module__p-t-18___jCusE`,
	"pT20": `PatientInfoModule-module__p-t-20___Gb4hn`,
	"pT30": `PatientInfoModule-module__p-t-30___OV56G`,
	"pT40": `PatientInfoModule-module__p-t-40___HNF4f`,
	"pT50": `PatientInfoModule-module__p-t-50___WNuPb`,
	"pL20": `PatientInfoModule-module__p-l-20___nECSM`,
	"pL30": `PatientInfoModule-module__p-l-30___hN3Xw`,
	"pL40": `PatientInfoModule-module__p-l-40___SvDr0`,
	"pR16": `PatientInfoModule-module__p-r-16___bYZhe`,
	"pR20": `PatientInfoModule-module__p-r-20___qAmGS`,
	"pR30": `PatientInfoModule-module__p-r-30___I0CmU`,
	"pR50": `PatientInfoModule-module__p-r-50___JThlO`,
	"pR60": `PatientInfoModule-module__p-r-60___hvAq_`,
	"mB1": `PatientInfoModule-module__m-b-1___GDExR`,
	"mB2": `PatientInfoModule-module__m-b-2___bPAO3`,
	"mB6": `PatientInfoModule-module__m-b-6___jzdsV`,
	"mB8": `PatientInfoModule-module__m-b-8___WmZKS`,
	"mB10": `PatientInfoModule-module__m-b-10___HfH2e`,
	"mB14": `PatientInfoModule-module__m-b-14___olKRt`,
	"mB16": `PatientInfoModule-module__m-b-16___VApka`,
	"mB20": `PatientInfoModule-module__m-b-20___Hr8an`,
	"mB22": `PatientInfoModule-module__m-b-22___uK01b`,
	"mB24": `PatientInfoModule-module__m-b-24___BdwaT`,
	"mB30": `PatientInfoModule-module__m-b-30___IH7uq`,
	"mB32": `PatientInfoModule-module__m-b-32___P0ujz`,
	"mB40": `PatientInfoModule-module__m-b-40___fpHQK`,
	"mT2": `PatientInfoModule-module__m-t-2___e23zj`,
	"mT3": `PatientInfoModule-module__m-t-3___MlnYE`,
	"mT4": `PatientInfoModule-module__m-t-4___APdnn`,
	"mT5": `PatientInfoModule-module__m-t-5___ywnQX`,
	"mT8": `PatientInfoModule-module__m-t-8___yA3pd`,
	"mT10": `PatientInfoModule-module__m-t-10___eyPeV`,
	"mT15": `PatientInfoModule-module__m-t-15___SMgh9`,
	"mT16": `PatientInfoModule-module__m-t-16___ZlgnW`,
	"mT20": `PatientInfoModule-module__m-t-20___ykiz8`,
	"mT22": `PatientInfoModule-module__m-t-22___F4MaJ`,
	"mT30": `PatientInfoModule-module__m-t-30___ocAK0`,
	"mT32": `PatientInfoModule-module__m-t-32___UggSp`,
	"mLAuto": `PatientInfoModule-module__m-l-auto___V4jKH`,
	"mL4": `PatientInfoModule-module__m-l-4___qf1vx`,
	"mL5": `PatientInfoModule-module__m-l-5___t04Lm`,
	"mL6": `PatientInfoModule-module__m-l-6___d7syO`,
	"mL8": `PatientInfoModule-module__m-l-8___ZtqUZ`,
	"mL10": `PatientInfoModule-module__m-l-10___wzunu`,
	"mL16": `PatientInfoModule-module__m-l-16___wIq6E`,
	"mL20": `PatientInfoModule-module__m-l-20___HURVY`,
	"mL24": `PatientInfoModule-module__m-l-24___Y8rD8`,
	"mL30": `PatientInfoModule-module__m-l-30___DeXXm`,
	"mL35": `PatientInfoModule-module__m-l-35___ILPqA`,
	"mL40": `PatientInfoModule-module__m-l-40____a9fA`,
	"mR8": `PatientInfoModule-module__m-r-8___GTxoa`,
	"mR10": `PatientInfoModule-module__m-r-10___MeIbP`,
	"mR16": `PatientInfoModule-module__m-r-16___GZO3I`,
	"mR20": `PatientInfoModule-module__m-r-20___hVM34`,
	"mR24": `PatientInfoModule-module__m-r-24___ckHfw`,
	"mR30": `PatientInfoModule-module__m-r-30___t9vOh`,
	"mR40": `PatientInfoModule-module__m-r-40___cP7Cv`,
	"borderR3": `PatientInfoModule-module__border-r-3___KuLPh`,
	"borderR4": `PatientInfoModule-module__border-r-4___gQ7d4`,
	"borderR6": `PatientInfoModule-module__border-r-6___WLhei`,
	"borderR10": `PatientInfoModule-module__border-r-10___YZUYs`,
	"borderR12": `PatientInfoModule-module__border-r-12___m8yL_`,
	"borderR16": `PatientInfoModule-module__border-r-16___d1U05`,
	"borderR50": `PatientInfoModule-module__border-r-50___X1qC5`,
	"primaryBorder": `PatientInfoModule-module__primary-border___Wohq_`,
	"primaryBorderB": `PatientInfoModule-module__primary-border-b___HkGaw`,
	"primaryBorderT": `PatientInfoModule-module__primary-border-t___YrN7Q`,
	"primaryBorderL": `PatientInfoModule-module__primary-border-l___Mdd4v`,
	"primaryBorderR": `PatientInfoModule-module__primary-border-r___i8J4K`,
	"secondaryBorder": `PatientInfoModule-module__secondary-border___eYGbv`,
	"secondaryBorderB": `PatientInfoModule-module__secondary-border-b___dVOcX`,
	"secondaryBorderT": `PatientInfoModule-module__secondary-border-t___LAOMe`,
	"secondaryBorderL": `PatientInfoModule-module__secondary-border-l___QzkCq`,
	"secondaryBorderR": `PatientInfoModule-module__secondary-border-r___Nmkhh`,
	"gap0": `PatientInfoModule-module__gap-0___qTCH_`,
	"gap2": `PatientInfoModule-module__gap-2___JAXUg`,
	"gap4": `PatientInfoModule-module__gap-4___gMvdH`,
	"gap5": `PatientInfoModule-module__gap-5___RURvz`,
	"gap6": `PatientInfoModule-module__gap-6___BjZAl`,
	"gap8": `PatientInfoModule-module__gap-8___mmsPl`,
	"gap10": `PatientInfoModule-module__gap-10___MReq3`,
	"gap12": `PatientInfoModule-module__gap-12___d_jeZ`,
	"gap14": `PatientInfoModule-module__gap-14___fjnle`,
	"gap16": `PatientInfoModule-module__gap-16___MaReI`,
	"gap18": `PatientInfoModule-module__gap-18___CMn4k`,
	"gap20": `PatientInfoModule-module__gap-20___X3WPC`,
	"gap24": `PatientInfoModule-module__gap-24___nvR9U`,
	"gap26": `PatientInfoModule-module__gap-26___hN5dc`,
	"gap30": `PatientInfoModule-module__gap-30___cCA0m`,
	"gap32": `PatientInfoModule-module__gap-32___EXNdv`,
	"gap40": `PatientInfoModule-module__gap-40___sUr24`,
	"gap50": `PatientInfoModule-module__gap-50___JuGIQ`,
	"flex1": `PatientInfoModule-module__flex-1___buodj`,
	"flexNone": `PatientInfoModule-module__flex-none___NmeqD`,
	"flexColumn": `PatientInfoModule-module__flex-column___a8_91`,
	"flexRow": `PatientInfoModule-module__flex-row___rpblU`,
	"verticallyCentered": `PatientInfoModule-module__vertically-centered___r57SY`,
	"horizontallyCentered": `PatientInfoModule-module__horizontally-centered___H5as6`,
	"horizontallyEnd": `PatientInfoModule-module__horizontally-end___FZJRY`,
	"verticallyStart": `PatientInfoModule-module__vertically-start___YNKAy`,
	"spaceBetween": `PatientInfoModule-module__space-between___rr_UH`,
	"flexWrap": `PatientInfoModule-module__flex-wrap___N2lHI`,
	"height100": `PatientInfoModule-module__height-100___03Dxh`,
	"width50": `PatientInfoModule-module__width-50___mBc5N`,
	"width100": `PatientInfoModule-module__width-100___MZPCf`,
	"cursorPointer": `PatientInfoModule-module__cursor-pointer___IQDKS`,
	"cursorNotAllowed": `PatientInfoModule-module__cursor-not-allowed___byiNC`,
	"absoluteCentered": `PatientInfoModule-module__absolute-centered___PfXWW`,
	"absolute": `PatientInfoModule-module__absolute___KzzTK`,
	"relative": `PatientInfoModule-module__relative___UDOko`,
	"fixed": `PatientInfoModule-module__fixed___JfwcO`,
	"visible": `PatientInfoModule-module__visible___WCZo8`,
	"invisible": `PatientInfoModule-module__invisible___eNWWI`,
	"col90": `PatientInfoModule-module__col-90___i894H`,
	"colAuto": `PatientInfoModule-module__col-auto___nPAtt`,
	"medicalTabs": `PatientInfoModule-module__medical-tabs___n1ckP`,
	"medicalTableNew": `PatientInfoModule-module__medical-table-new___M2D9m`,
	"noPagination": `PatientInfoModule-module__no-pagination___hxVH4`,
	"medicalTableEmpty": `PatientInfoModule-module__medical-table-empty___WdLsC`,
	"iconBtn": `PatientInfoModule-module__icon-btn___nxQRu`,
	"searchIcon": `PatientInfoModule-module__search-icon___UY43E`,
	"disableSelect": `PatientInfoModule-module__disable-select___AuMDx`,
	"breakWord": `PatientInfoModule-module__break-word___j2w8S`,
	"popupClearBtn": `PatientInfoModule-module__popup-clear-btn___REkck`,
	"scrollMB20": `PatientInfoModule-module__scroll-m-b-20___Vb1B0`,
	"grid": `PatientInfoModule-module__grid___PR8xf`
};
module.exports = ___CSS_LOADER_EXPORT___;
